/**
 * Modelos prontos de automação do Instagram — o ponto de partida da tela
 * "Nova automação". Em `shared/` porque a tela mostra a lista e o servidor
 * não precisa deles: o modelo só preenche o formulário; quem grava é a
 * mutation normal.
 *
 * Texto voltado ao público brasileiro: as palavras-chave são as que as
 * pessoas realmente digitam nos comentários por aqui.
 */

export type InstagramAutomationTemplate = {
  slug: string;
  title: string;
  category: string;
  summary: string;
  keywords: string[];
  dmMessage: string;
  linkButtonLabel: string;
  publicReplyMessages: string[];
  /** Como a pessoa comentaria, para a prévia. */
  triggerExample: string;
};

export const INSTAGRAM_AUTOMATION_TEMPLATES: InstagramAutomationTemplate[] = [
  {
    slug: "link-na-dm",
    title: "Link na DM",
    category: "O clássico",
    summary: "Quem comenta a palavra recebe o link no privado. Serve para qualquer post.",
    keywords: ["link", "quero", "eu quero"],
    dmMessage: "Oi {nome}! Aqui está o link que você pediu 👇",
    linkButtonLabel: "Abrir link",
    publicReplyMessages: [
      "Te mandei no privado! 📩",
      "Acabei de enviar na sua DM 😉",
      "Olha a caixinha de mensagens! 💬",
    ],
    triggerExample: "LINK",
  },
  {
    slug: "material-gratuito",
    title: "Material gratuito (isca)",
    category: "Captação de leads",
    summary: "Entrega um e-book, planilha ou aula gratuita e traz a pessoa para a conversa.",
    keywords: ["material", "quero o material", "ebook", "planilha"],
    dmMessage:
      "Oi {nome}! Aqui está o material que prometi no post. Qualquer dúvida é só me responder por aqui 😊",
    linkButtonLabel: "Baixar material",
    publicReplyMessages: ["Enviei no seu privado! 📩", "Já está na sua DM 🚀"],
    triggerExample: "quero o material",
  },
  {
    slug: "preco-e-orcamento",
    title: "Preço e orçamento",
    category: "Vendas",
    summary: "Quem pergunta preço no post recebe a tabela ou o link do WhatsApp comercial.",
    keywords: ["preço", "valor", "quanto custa", "orçamento"],
    dmMessage:
      "Oi {nome}! Vi que você quer saber o valor. Toque abaixo para ver a tabela completa ou falar direto com a nossa equipe 👇",
    linkButtonLabel: "Ver valores",
    publicReplyMessages: ["Te chamei no privado com os valores 😉", "Mandei tudo na DM! 📩"],
    triggerExample: "quanto custa?",
  },
  {
    slug: "inscricao-evento",
    title: "Inscrição em evento ou aula",
    category: "Eventos",
    summary: "Envia o link de inscrição da live, do workshop ou do curso para quem comentou.",
    keywords: ["inscrição", "quero participar", "vaga", "eu vou"],
    dmMessage: "Oi {nome}! Sua vaga está a um toque de distância. Garanta aqui 👇",
    linkButtonLabel: "Garantir vaga",
    publicReplyMessages: ["Link de inscrição no seu privado! 🎟️", "Te mandei o link na DM 😉"],
    triggerExample: "EU VOU",
  },
  {
    slug: "agendamento",
    title: "Agendar horário",
    category: "Serviços",
    summary: "Clínicas, salões e consultórios: quem comenta recebe o link da agenda.",
    keywords: ["agendar", "horário", "quero agendar", "marcar"],
    dmMessage: "Oi {nome}! Escolha o melhor horário para você aqui 👇",
    linkButtonLabel: "Ver horários",
    publicReplyMessages: ["Te mandei o link da agenda no privado 📅"],
    triggerExample: "quero agendar",
  },
  {
    slug: "cupom",
    title: "Cupom de desconto",
    category: "E-commerce",
    summary: "Libera o cupom no privado para quem comentou — e você mede quem usou.",
    keywords: ["cupom", "desconto", "quero o cupom"],
    dmMessage: "Oi {nome}! Seu cupom é BEMVINDO10. Use nesta página 👇",
    linkButtonLabel: "Usar cupom",
    publicReplyMessages: ["Cupom enviado na DM! 🎁", "Olha o privado 😉"],
    triggerExample: "CUPOM",
  },
];
